import BaseModule from '$src/js/modules/base/BaseModule';

declare global {
  interface Window {
    app: Bootstrap;
  }
}

export default class Bootstrap {
  constructor() {
    BaseModule.getInstance().boot();
  }

  static getInstance(): Bootstrap {
    if (typeof window.app === 'undefined') {
      window.app = new Bootstrap();
    }

    return window.app;
  }
}
